import React from 'react';
import {createRoot} from 'react-dom/client';
import queryString from 'query-string';
import {SENTRY_RELEASE, SENTRY_DSN_VIEWERS, GIT_COMMIT_SHA} from '@swipe-guide/clients-shared/constants';

//sentry
import * as Sentry from '@sentry/react';
Sentry.init({
  dsn: SENTRY_DSN_VIEWERS || '',
  release: SENTRY_RELEASE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  initialScope: {
    tags: {git_commit: GIT_COMMIT_SHA}
  },
  environment: process.env.NODE_ENV
});

//mobx
import store from 'stores/store';
import {Provider} from 'mobx-react';

//apollo
import {ApolloProvider} from '@apollo/client';
import {client} from 'utils/apollo-client';

//router
import {startRouter} from 'mobx-router';
import views from 'config/views';
import {normalizeCurrentUrl} from '@swipe-guide/clients-shared/utils/url-utils';

//components
import App from 'components/App';

import 'styles/index.css';
import 'shared/styles/css/lato.css';
import {GlobalStyles} from '@swipe-guide/clients-shared/theme-config';

import {browserDetect, navigationTracking} from '@swipe-guide/clients-shared/utils/generic-utils';

normalizeCurrentUrl();
startRouter(views, store, {
  // https://github.com/flatiron/director#configuration
  strict: false
});

if (browserDetect.isIE11) {
  document.documentElement.className += ' is-ie-11';
}

if (browserDetect.isEdge) {
  document.documentElement.className += ' is-edge';
}

// This will clear all existing awsalb cookies out there #2431
// TODO: remove this let's say in 2 months
document.cookie = 'AWSALB=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

const {redirect_referrer: redirectReferrer = ''} = queryString.parse(window.location.search);

navigationTracking.add(decodeURIComponent(redirectReferrer) || document.referrer);

const root = createRoot(document.getElementById('root'));
root.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <App />
      <GlobalStyles />
    </Provider>
  </ApolloProvider>
);
